import { useQuery } from '@tanstack/react-query';
import { fetchData } from 'utils';
import useSmartlook from 'hooks/useSmartlook';

export function useConstraintsQuery(enabled = true) {
  const { error } = useSmartlook();
  return useQuery<Constraints>({
    queryKey: ['constraints'],
    queryFn: async () => {
      try {
        const data = await fetchData('/application/constraints');

        // HOTFIX: Smash the max and default value - this piece of code will be removed in a few days (BE will implement it properly)
        return {
          ...data,
          amountInterval: {
            ...data.amountInterval,
            defaultValue: 16000,
            max: 16000,
          },
          loanLimits: {
            1: 16000,
          },
        };
      } catch (e) {
        error('[useConstraintsQuery][GET /application/constraints]', e);
        throw e;
      }
    },
    enabled,
    staleTime: Infinity,
  });
}

export type Constraints = {
  loanLimits: {
    1: number;
    2: number;
  };
  amountInterval: {
    min: number;
    max: number;
    step: number;
    defaultValue: number;
  };
  termInterval: {
    min: number;
    max: number;
    step: number;
    defaultValue: number;
  };
  termLimits?: any[];
  _links?: {
    self: {
      href: string;
      title: string;
    };
  };
};
